module.exports = __webpack_public_path__ + "static/media/mail.8708622d.svg";